export enum ShortcutSection {
    CAMERA = 'videocam',
    POI = 'location_on',
    ARTICLE = 'deployed_code',
    SELECTION = 'select',
    PLACEMENT = 'auto_fix'
}
